import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncCvrsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncCvrsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid => navigate(atlasRoutes.syncCvrsView({ params: { syncCvrId: uuid } }).path)}
      />
    </div>
  );
};
